import UserActions from "../Types";
import responseHandler from "../../utils/responseHandler";
import Instance from "../../utils/apiCert";
import Storage from "../../utils/storage";

// GET TEST LOGS
export const getTestLogsStart = () => ({
    type: UserActions.GET_TESTCASE_LOGS_START
})

export const getTestLogsSuccess = payload => ({
    type: UserActions.GET_TESTCASE_LOGS_SUCCESS,
    payload
})

export const getTestLogsFailure = payload => ({
    type: UserActions.GET_TESTCASE_LOGS_FAILURE,
    payload
})

// RUN TEST CASES
export const runTestCasesStart = () => ({
    type: UserActions.RUN_TEST_START
})

export const runTestCasesSuccess = payload => ({
    type: UserActions.RUN_TEST_SUCCESS,
    payload
})

export const runTestCasesFailure = payload => ({
    type: UserActions.RUN_TEST_FAILURE,
    payload
})

// SUBMIT TEST RESULTS
export const submitTestResultStart = () => ({
    type: UserActions.SUBMIT_TEST_RESULTS_START
})

export const submitTestResultSuccess = payload => ({
    type: UserActions.SUBMIT_TEST_RESULTS_SUCCESS,
    payload
})

export const submitTestResultFailure = payload => ({
    type: UserActions.SUBMIT_TEST_RESULTS_FAILURE,
    payload
})

// SUBMIT AGREEMENT
export const submitAgreementStart = () => ({
    type: UserActions.SUBMIT_AGREEMENT_START
})

export const submitAgreementSuccess = payload => ({
    type: UserActions.SUBMIT_AGREEMENT_SUCCESS,
    payload
})

export const submitAgreementFailure = payload => ({
    type: UserActions.SUBMIT_AGREEMENT_FAILURE,
    payload
})
export const resetSubmitAgreementStatus = () => ({
  type: UserActions.RESET_SUBMIT_AGREEMENT_STATUS,
});

export const clearCheckState = () => ({
    type: UserActions.CLEAR_CHECK_STATUS,
})

export const getTestLogs = (tid, merchant_class) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))
    console.log(tid, merchant_class)

    dispatch(getTestLogsStart());
    API.get(`certification/kafka/${tid}?merchant_class=${merchant_class}`).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if(ok) {
            dispatch(getTestLogsSuccess(data.data));
        } else {
            dispatch(getTestLogsFailure(data));
        }
    })
}

export const runTestCases = (tid, merchant_class) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))

    dispatch(runTestCasesStart());
    API.get(`certification/kafka/${tid}?merchant_class=${merchant_class}`).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if(ok) {
            dispatch(runTestCasesSuccess(data.data));
        } else {
            dispatch(runTestCasesFailure(data));
        }
    })
}

export const submitTestResult = (payload) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))

    dispatch(submitTestResultStart());
    API.post("certification/test", payload).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if(ok) {
            dispatch(submitTestResultSuccess(data.success));
        } else {
            dispatch(submitTestResultFailure(data));
        }
    })
}

export const submitAgreement = (payload) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))

    dispatch(submitAgreementStart());
    API.post("certification/terms/agree", payload).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if(ok) {
            dispatch(submitAgreementSuccess(data.success));
            dispatch(clearCheckState())
        
        } else {
            dispatch(submitAgreementFailure(data));
        }
    })
}
